var _path, _rect, _rect2, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8829 17.3047L22.8203 17.3646L18.9477 9.40936L16.0001 9.3516L19.8829 17.3047Z",
    fill: "#00CCFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 2.50635,
    width: 2.69798,
    height: 14.84,
    fill: "#00CCFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.698,
    y: 9.69629,
    width: 2.90501,
    height: 5.39597,
    transform: "rotate(-90 13.698 9.69629)",
    fill: "#66E0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0932 9.69566L22.8036 1.27168L19.0528 3.06902L16.0719 9.69565L19.0932 9.69566Z",
    fill: "#66E0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01489 6.028L10.4687 2.56921V17.4105H8.01489V6.028Z",
    fill: "#66E0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4686 6.02793L10.4686 2.55727L-6.18496e-05 17.4105L3.35556 17.4057L5.88494 13.3598L10.4686 6.02793Z",
    fill: "#00CCFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLogo);
export default __webpack_public_path__ + "static/media/personal-logo.895a5821b501a0294f4abd210a761451.svg";
export { ForwardRef as ReactComponent };